import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TrustSignal {
  icon: string;
  value: string;
  label: string;
}

const TrustSignals = () => {
  const signals: TrustSignal[] = [
    { icon: 'UserGroupIcon', value: '50,000+', label: 'Active Learners' },
    { icon: 'AcademicCapIcon', value: '200+', label: 'Expert Instructors' },
    { icon: 'BookOpenIcon', value: '500+', label: 'Courses Available' },
    { icon: 'StarIcon', value: '4.8/5', label: 'Average Rating' },
  ];

  return (
    <section className="bg-transparent py-12 border-y border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {signals.map((signal, index) => (
            <div key={index} className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 backdrop-blur-md rounded-full mb-4 border border-white/20">
                <Icon name={signal.icon as any} size={32} variant="solid" className="text-primary" />
              </div>
              <p className="font-headline text-3xl font-bold text-white mb-1 drop-shadow-lg">{signal.value}</p>
              <p className="text-sm text-white/80 font-medium drop-shadow-md">{signal.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;